import type { SxProps } from "@mui/material/styles"

import { gridClasses } from "@mui/x-data-grid"

/**
 * Finds the first occurrence of an error by checking the DOM and finding the first element with class "Mui-error".
 * If it exists, scrolls to the error element.
 */
export const scrollToMuiError = () => {
    const errorElement = document.querySelector(".Mui-error")
    if (errorElement) {
        errorElement.scrollIntoView({ behavior: "smooth", block: "center" })
    }
}

export const getDataGridStyles = (paperColor: string): SxProps => ({
    [`& .${gridClasses.cell}`]: { alignItems: "center", display: "inline-flex", lineHeight: "initial" },
    ".MuiDataGrid-columnHeader": { height: "30px !important" },
    [`& .${gridClasses["columnHeader--pinnedRight"]}`]: {
        backgroundColor: "var(--palette-background-neutral)",
    },
    [`& .${gridClasses["scrollbarFiller--pinnedRight"]}`]: {
        backgroundColor: "var(--palette-background-neutral) !important",
    },
    [`& .${gridClasses["cell--pinnedRight"]}`]: {
        boxShadow: "-8px 8px 17px -8px rgba(145 158 171 / 0.2)",
        backgroundColor: `${paperColor} !important`,
    },
    [`& .${gridClasses["filler--pinnedRight"]}`]: {
        borderLeft: "none",
        backgroundColor: `${paperColor} !important`,
    },
})

export const allowedCountryCodesForPhone = /^(91|63)\d{10}$/
export const allowedCountriesForPhone = ["IN", "PH"]
export const phoneNumberMaxLength = 10
